import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const buttonVariants = cva(
	'inline-flex items-center justify-center hover:opacity-90 rounded-full text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ring-offset-background',
	{
		variants: {
			variant: {
				default: 'bg-accent px-5 py-3 text-accent-foreground shadow-glow hover:opacity-95',
				outline: 'border border-border bg-card px-5 py-3 text-foreground hover:border-accent hover:text-accent',
			},
			size: {
				default: 'h-11',
				lg: 'h-12 px-6',
			},
		},
		defaultVariants: {
			variant: 'default',
			size: 'default',
		},
	}
);

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
	VariantProps<typeof buttonVariants> & {
		asChild?: boolean;
	};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, variant, size, asChild = false, ...props }, ref) => {
	const Comp = asChild ? 'span' : 'button';

	return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref as never} {...props} />;
});

Button.displayName = 'Button';

export { Button, buttonVariants };
